import { Box } from "@mui/material"
import { FilterAltOutlined } from "@mui-symbols-material/w300"
import type { ChangeEvent, FC, ReactElement } from "react"

import { useWarehouseShelvingSearch } from "../hooks/useWarehouseShelvingSearch"

import { Button } from "@/components/common/Button"
import SearchInput from "@/components/SearchInput/SearchInput"

interface WarehouseShelvingSearchProps {
  onFilterOpen: () => void
}

export const WarehouseShelvingSearch: FC<WarehouseShelvingSearchProps> = ({ onFilterOpen }): ReactElement => {
  const { searchValue, updateNavigationSearch } = useWarehouseShelvingSearch()

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const queryValue = e.target.value

    updateNavigationSearch(queryValue)
  }

  return (
    <Box className='flex items-center justify-start gap-4 py-4' data-testid='warehouse-shelving-search-container'>
      <SearchInput
        placeholder='Search by Location'
        defaultValue={searchValue}
        onChange={handleInputChange}
        className='w-full max-w-xl'
      />
      <Button
        aria-label='filter'
        appearance='outlined'
        onClick={onFilterOpen}
        startIcon={<FilterAltOutlined />}
        data-testid='warehouse-shelving-filter-button'
      >
        Filter
      </Button>
    </Box>
  )
}
